<app-oncall-home></app-oncall-home>
@if (pageEnabled) {
  <div style="display: flex; flex-direction: column; align-items: center;">
    <p class="teams-header">Teams</p>
    <div style="display: flex; align-items: center;">
      <div class="button-wrapper">
        <button mat-raised-button class="button" (click)="openCreateTeamDialog()">Create Team</button>
      </div>
    </div>
    <div>
      <table class="mat-elevation-z8" #teamsTable mat-table [dataSource]="dataSource" multiTemplateDataRows
        aria-describedby="teams">
        @for (column of columns; track column) {
          <ng-container [matColumnDef]="column.columnDef">
            <th mat-header-cell class="header-row" *matHeaderCellDef>
            {{ column.header }}</th>
            <td mat-cell *matCellDef="let team">
              @if (column.columnDef !== 'splunkOnCallIntegrated') {
                {{ column.cell(team) }}
              } @else {
                @if (team.splunkOnCallIntegrated) {
                  <mat-icon class="material-icons-outlined"
                  style="color: #0093a1">done</mat-icon>
                }
                @if (!team.splunkOnCallIntegrated) {
                  <mat-icon class="material-icons-outlined"
                  style="color: red">close</mat-icon>
                }
              }
            </td>
          </ng-container>
        }
        <ng-container matColumnDef="action">
          <th mat-header-cell class="header-row" *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let team">
            <button mat-icon-button class="material-icons app-toolbar-menu save-button" matTooltip="Edit" color="primary"
              (click)="editTeam(team)">
              <mat-icon>edit</mat-icon>
            </button>
            <button [disabled]="!isPlatform" mat-icon-button class="material-icons app-toolbar-menu delete-button" matTooltip="Delete" color="warn"
              (click)="confirmAction('Are you sure you want to delete this team?', deleteTeam, team)">
              <mat-icon>delete</mat-icon>
            </button>
            <button mat-icon-button class="material-icons app-toolbar-menu alertTeam-button"  matTooltip="Alert On Call"
              (click)="openAlertOnCallDialog(team)" color="warn">
              <mat-icon>add_alert</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
        <tr #tableRow mat-row *matRowDef="let teams; columns: displayedColumns;" style="height: 40px;">
        </tr>
      </table>
    </div>
  </div>
} @else {
  <div>
    <h2>This page has been temporarily disabled by the Platform Team.</h2>
  </div>
}

